// ── Deployment target ───────────────────────────────────────────────────
// ONE switch decides which backend the whole app talks to. It is set at
// build time, so you never edit source to flip environments:
//
//   npm run build:prod  → live vicuscapital.com   (prod gateway + `types`)
//   npm run build:test  → test.vicuscapital.com   (dev gateway + `devtypes`)
//
// Plain `npm run build` and local `npm start` leave the var unset and fall
// back to the test/dev backend, so a forgotten flag can never ship prod data
// or mutate production while developing. Every dependent value below derives
// from `isProd`, and submissionService imports it — so there is no second
// place to keep in sync.
const isProd = process.env.REACT_APP_DEPLOY_ENV === "prod";

const config = {
  MAX_ATTACHMENT_SIZE: 60 * 1000000, // number * 1MB
  FORMS_BUCKET: "vicus-proposal-forms",
  isProd,
  // proposal-types DynamoDB table: live `types` in prod, `devtypes` elsewhere.
  proposalTypesType: isProd ? "types" : "devtypes",
  s3: {
    REGION: "us-east-2",
    BUCKET: "vicus-proposal-forms",
  },
  apiGateway: {
    REGION: "us-east-2",
    URL: isProd
      ? "https://8lvg9c2kw8.execute-api.us-east-2.amazonaws.com/prod"
      : "https://8lvg9c2kw8.execute-api.us-east-2.amazonaws.com/dev",
    FILELIMIT: 4194304,
  },
  cognito: {
    REGION: "us-east-2",
    USER_POOL_ID: "us-east-2_LOYzLy1zt",
    APP_CLIENT_ID: "1j4fbvhn7gqhsutobj5peqr8se",
    IDENTITY_POOL_ID: "us-east-2:6c088227-436a-4e08-a100-392e33b1b164",
  },
  sessionLock: {
    enabled: process.env.REACT_APP_SESSION_LOCK_ENABLED !== "false",
    group: process.env.REACT_APP_SESSION_LOCK_GROUP || "proposal-generator",
    cookieDomain:
      process.env.REACT_APP_SESSION_LOCK_COOKIE_DOMAIN ||
      (process.env.NODE_ENV === "production" ? ".vicuscapital.com" : ""),
    isLoginPortal: process.env.REACT_APP_IS_LOGIN_PORTAL === "true",
    loginPortalHost:
      process.env.REACT_APP_LOGIN_PORTAL_HOST || "login.vicuscapital.com",
    warningMs: 13 * 60 * 1000,
    timeoutMs: 15 * 60 * 1000,
    presenceStaleMs: 5 * 60 * 1000,
    activityThrottleMs: 1000,
  },
  sessionEdge: {
    enabled:
      process.env.REACT_APP_VC_SESSION_EDGE_ENABLED === "true" &&
      process.env.REACT_APP_SESSION_LOCK_ENABLED !== "false",
    cookieName: "vc_last_activity",
    cookieDomain:
      process.env.REACT_APP_SESSION_LOCK_COOKIE_DOMAIN ||
      (process.env.NODE_ENV === "production" ? ".vicuscapital.com" : ""),
    heartbeatPath: "/_/heartbeat",
    heartbeatThrottleMs: 60 * 1000,
  },
};
export default config;
